import { render, staticRenderFns } from "./DetailsOrder.vue?vue&type=template&id=05be06f4&scoped=true&"
import script from "./DetailsOrder.vue?vue&type=script&lang=js&"
export * from "./DetailsOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailsOrder.vue?vue&type=style&index=0&id=05be06f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be06f4",
  null
  
)

export default component.exports